import React from "react";
import { capitalizeFirstLetter } from "Utils/Utils";
import useVipAccountCache from "Utils/Hooks/useVipAccountCached";
import useSession from "Utils/Hooks/useSession";
import { useHistory } from "react-router-dom";
import { CUSTOMER_SERVICE_PHONE_NUMBER, PRODUCTTYPES } from "Utils/Constants";
import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import useMode, { MODE } from "Utils/Hooks/useMode";
import { faro } from "@grafana/faro-react";
import { Box, Collapse } from "@mui/material";
import "./Menu.scss";
import { Typography } from "@pav/pav-products-design-system";

const Menu = ({ firstName, lastName, isOpen }) => {
  const { setVipAccount } = useVipAccountCache();
  const mode = useMode();
  const { session, invalidateSession } = useSession();
  const history = useHistory();
  const vipApi = useVipApiFetcher();
  const logoutAction = async () => {
    await NotifyLogout();
  };
  const isVIPPreferred = session?.patronProductType === PRODUCTTYPES.PREFERRED;
  const productType = isVIPPreferred ? "VIP Preferred" : "VIP Online";
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;

  async function NotifyLogout() {
    const sessionId = JSON.parse(
      global.sessionStorage.getItem("vip-patron-session"),
    ).sessionId;
    if (!session.transactionSucceeded) {
      vipApi
        .fetch("/api/usertracking/cancelflow", "POST", {
          transactionStage:
            mode === "withdraw"
              ? "Withdrawal"
              : mode === MODE.manageBanks
                ? "AddFundingSource"
                : "Deposit",
          sessionId: sessionId,
        })
        .then((response) => {
          if (response.ok) {
            faro.api.pushEvent("User logged out");
            invalidateSession();
            setVipAccount(null);
            history.push("/logout");
          } else {
            faro.api.pushError(new Error("Logout Request Error"), {
              context: response,
            });
            if (response.status === 500) {
              console.error(response.statusText);
              history.push({
                pathname: "/error",
              });
            } else if (response.status === 401) {
              console.error(response.statusText);
              history.push({
                pathname: "/expired",
              });
            } else {
              response.json().then((data) => {
                console.error(data);
                onError(data);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          faro.api.pushError(new Error("Logout Network Error"), {
            context: error,
          });
          history.push({
            pathname: "/error",
          });
        });
    } else {
      invalidateSession();
      setVipAccount(null);
      history.push("/logout");
    }
  }

  function onError(response) {
    history.push({
      pathname: "/error",
      state: {
        isError: true,
        showButton: true,
        title: "Request Failed. Please Try Again",
        message:
          response.patronErrorMessage ??
          "We are unable to complete this request. Please contact our Customer Service Team at 1-800-500-1973. Reference code E-30 so that we may better serve you.",
        allowRetry: false,
      },
    });
  }

  return (
    <Collapse in={isOpen} sx={{ width: "100%" }}>
      <Box className={"nav"}>
        <Box className={"nav-items"}>
          {firstName && (
            <Box className={"nav-item"} data-testid="menu-profile-btn">
              Welcome, {capitalizeFirstLetter(firstName)}{" "}
              {capitalizeFirstLetter(lastName)}!
            </Box>
          )}
          {firstName && (
            <Box
              className={"nav-item"}
              onClick={logoutAction}
              data-testid="menu-logout-btn"
            >
              Close {productType}
            </Box>
          )}
          <Box
            className={"nav-item"}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Box>Need support?</Box>
            <Box>
              Call CAMS:{" "}
              <Typography
                component={"a"}
                href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`}
                sx={{ color: "white", textDecoration: "none" }}
              >
                1-800-500-1973
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Collapse>
  );
};

export default Menu;
